import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { Spinner } from "reactstrap";
import axios from "axios";
import Dropdown from "../../components/page/map/Dropdown/ClientImpersonationDropdown";
import Button from "../../components/general/Button/Button";


import PrivateRouteWrapper from "../../wrappers/PrivateRouteWrapper";
import Header from "../../components/wrapper/Header/Header";
import SideBar from "../../components/wrapper/SideBar/ClientImpersonationSideBar";
import Content from "../../components/wrapper/Content/Content";
import Map from "../../pages/client/MapPage";
import Analytics from "../../pages/client/AnalyticsPage";
import Loading from "../../components/wrapper/Loading/Loading";
import * as actionTypes from "../../store/actions/actionTypes";

import truckColors from "../../assets/truckRouteColors";
import blendedColors from "../../assets/blendedRouteColors";
import macroColors from "../../assets/macroRouteColors";
import repColors from "../../assets/repRouteColors";

const inventoryCampaigns = {
  LA: 71,
  NYC: 72,
  SF: 73
};

class ClientImpersonationPage extends Component {
  state = {
    loading: false,
    loadedUser: false,
    client: {
      name: "Client",
      id: this.props.match.params.client_id
    },
    campaigns: {},
    showDropdown: false,
    heatmapView: true,

  };
  componentDidMount() {
    console.log('client_id', this.props.match.params.client_id);
    console.log('campaign_id', this.props.match.params.campaign_id);
    if (this.props.match.params.client_id) {
      this.loadUser();
      this.getClientName(this.props.match.params.client_id);
    }
  }

  toggleDropdown = () => {
    let current_state = this.state.showDropdown;
    this.setState({
      showDropdown: !current_state,
    });
  };
  changeCampaign = (campaign_id) =>{
    this.setState({
      showDropdown: false
    });
    this.props.history.push(`/dashboard/admin/advertise/client/impersonate/${this.props.match.params.client_id}/campaign/${campaign_id}/map`);

  }

  async componentDidUpdate(prevProps, prevState) {

    if (this.props.match.params.client_id && !this.state.loadedUser) {
      this.loadUser();

      this.setState({
        loadedUser: true
      });
    } else {
      // check if vehicles exist if selected campaign changes
      if (prevProps.match.params.campaign_id !== this.props.match.params.campaign_id) {
        let selected = this.props.match.params.campaign_id;
        if (
          this.state.campaigns[selected]
        ) {
          let vehicles = await this.getVehicles(selected);
          let clientName = await this.getClientName(this.props.match.params.client_id);
          this.props.onCampaignLoad(this.state.campaigns, selected);
          this.props.updateCampaignVehicles(selected, vehicles)
        }
      }
    }
  }

  loadUser() {
    let inventory = this.props.match.params.inventory ? inventoryCampaigns[this.props.match.params.inventory] : null;
    axios
      .get(`${process.env.REACT_APP_API_HOST}/user/${this.props.match.params.client_id}/campaign`, { withCredentials: true })
      .then(async (response) => {
        let campaigns = {};
        let first = null;
        if (response.data.campaigns[0].id) {
          response.data.campaigns.map((campaign) => {
            if (!first) {
              first = campaign.id;
            }
            campaigns[campaign.id] = {
              name: campaign.name,
              vehicles: {},
              csv_report_enabled: campaign.csv_report_enabled,
              startDate: campaign.start_date,
              endDate: campaign.end_date
            };
          });

        }
        else {
          first = 0;
          campaigns[0] = {
            name: "",
            vehicles: {}
          };
        }
        if (first) {
          // load first campaigns routes
          campaigns[this.props.match.params.campaign_id].vehicles = await this.getVehicles(this.props.match.params.campaign_id);
        }
        console.log(campaigns);
        this.setState({
          campaigns: campaigns
        });
        this.props.onCampaignLoad(campaigns, inventory ? inventory : this.props.match.params.campaign_id);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async getClientName(id){
    try{
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/user/${id}`, {withCredentials: true });
      if (res.status === 200){
        this.setState({
          client: {
            name: res.data.user[0].name,
            id: id,
          }
        });
      }
    }
    catch (err){
      console.log(err);
    }
  }

  async getVehicles(id) {
    this.setState({
      loading: true
    });
    let vehicles = {};
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/campaign/${id}/truck/routes`, {
        withCredentials: true
      });
      if (res.status === 200) {
        res.data.trucks.map((truck, index) => {
          let colorIndex = index % truckColors.length;
          if (truck.id) {
            vehicles[`truck-${truck.id}`] = {
              imei: truck.imei,
              name: truck.display_name,
              analytics: truck.analytics,
              paths: truck.paths,
              color: truckColors[colorIndex],
              checked: true,
            };
          }
        });
        res.data.blended.map((blended, index) => {
          let colorIndex = index % blendedColors.length;
          if (blended.paths && blended.paths.length > 0) {
            vehicles[`blended-${blended.id}`] = {
              name: blended.display_name,
              analytics: blended.analytics,
              paths: blended.paths,
              color: blendedColors[colorIndex],
              checked: true,
            };
          }
        });
        res.data.placeholders.map((placeholder, index) => {
          let colorIndex = index % repColors.length;
          vehicles[`placeholder-${placeholder.id}`] = {
            name: placeholder.display_name,
            paths: placeholder.paths,
            color: repColors[colorIndex],
            checked: true,
          };
        });
        res.data.macros.map((macro, index) => {
          let colorIndex = index % macroColors.length;
          vehicles[`macro-${macro.id}`] = {
            name: macro.display_name,
            paths: macro.paths,
            color: macroColors[colorIndex],
            checked: true,
          };
        });
      }
    } catch (err) {
      console.log(err);
    }

    this.setState({
      loading: false
    });
    return vehicles;
  }
  render() {
    return (
      <Fragment>
        <Dropdown
        campaigns={this.state.campaigns}
        client={this.state.client}
        selected={this.props.match.params.campaign_id}
        toggleShow={this.toggleDropdown}
        show={this.state.showDropdown}
        changeCampaign = {(key) => this.changeCampaign(key)}>
        </Dropdown>
        <SideBar client={this.state.client} selected={this.props.match.params.campaign_id} setView={this.viewToggleHandler}/>
        <Content>
          <Switch>
          <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/advertise/client/impersonate/:client_id/campaign/:campaign_id/map" component={Map} />
          <PrivateRouteWrapper roles={[1, 2, 3]} path="/dashboard/admin/advertise/client/impersonate/:client_id/campaign/:campaign_id/analytics" component={Analytics} />
          </Switch>
        </Content>
        <Loading loading={this.state.loading} label="Loading Client View..." />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.user.id,
    campaigns: state.clientDashboard.campaigns,
    selected: state.clientDashboard.selected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCampaignLoad: (campaigns, selected) => {
      dispatch({
        type: actionTypes.LOAD_CLIENT_CAMPAIGNS,
        campaigns: campaigns,
        selected: selected
      });
    },
    updateCampaignVehicles: (campaignId, vehicles) => {
      dispatch({
        type: actionTypes.UPDATE_CAMPAIGN_VEHICLES,
        id: campaignId,
        vehicles: vehicles
      });
    }
  };
};

export default connect(null, mapDispatchToProps)(withRouter(ClientImpersonationPage));
